import { Box } from "@mui/material";
import styled from "styled-components";

export const SlugSonhosRealizadosDetails = styled.div`
  width: 100%;

  margin: 100px 0px 40px 0px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 0px 20px;

  .content {
    width: 100%;
    max-width: 1200px;
  }

  .content-page {
    width: 100%;

    display: flex;
    flex-direction: column;
    gap: 30px;
    margin-top: 20px;
  }
`;

export const Lista = styled(Box)`
  display: grid;

  grid-template-columns: 1fr 1fr;

  row-gap: 30px;
  column-gap: 20px;

  @media (max-width: 950px) {
    grid-template-columns: 1fr;
  }

  .item-list:only-child {
    grid-column: 1 / -1;
    height: 100%;
  }

  .item-list {
    flex-basis: 300px;
    border-radius: 16px;

    .img-item-list {
      width: 100%;
      height: 400px;
      object-fit: cover;
    }

    @media (max-width: 1200px) {
      flex-basis: 300px;
    }
  }
`;
